import FW from '../fw/fw';
import LocalStorage from '../fw/local-storage';


export default class AudioOnly {

  #rmp;
  #audioOnlyMinusFn = null;
  #audioOnlyPlusFn = null;
  #audioOnlyOnVolumeChangeFn = null;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  #audioOnlyPlus(event) {
    FW.eventStopPrevent(event);
    let currentVolume = this.#rmp.volume;
    if (currentVolume <= 1 && currentVolume >= 0) {
      currentVolume += 0.1;
      if (currentVolume >= 1) {
        currentVolume = 1;
      }
      this.#rmp.volume = currentVolume;
    }
  }

  #audioOnlyMinus(event) {
    FW.eventStopPrevent(event);
    let currentVolume = this.#rmp.volume;
    if (currentVolume <= 1 && currentVolume >= 0) {
      currentVolume -= 0.1;
      if (currentVolume <= 0) {
        currentVolume = 0;
      }
      this.#rmp.volume = currentVolume;
    }
  }

  #audioOnlyOnVolumeChange() {
    const isMuted = this.#rmp.mute;
    let currentVolume = 0;
    if (!isMuted) {
      currentVolume = this.#rmp.volume;
    }
    if (currentVolume >= 0 && currentVolume <= 1) {
      if (this.#rmp.rememberVolume && LocalStorage.available(this.#rmp.allowLocalStorage)) {
        LocalStorage.writeVolume(currentVolume);
      }
    }
    this.#rmp.dom.volume.classList.remove('rmp-i-volume-off', 'rmp-i-volume-half', 'rmp-i-volume');
    this.#rmp.rmpVolumeManagement.updateVolumeIcon(currentVolume);
    this.#rmp.dispatch('volumechange');
  }

  init() {
    const minus = FW.createElement(
      'button',
      'rmp-button rmp-i rmp-i-minus',
      null,
      null
    );
    this.#rmp.dom.controlBar.appendChild(minus);
    this.#rmp.rmpAccessible.button(minus, this.#rmp.labels.hint.minus, true);
    this.#audioOnlyMinusFn = this.#audioOnlyMinus.bind(this);
    FW.addEvents(['touchend', 'click'], minus, this.#audioOnlyMinusFn);

    const plus = FW.createElement(
      'button',
      'rmp-button rmp-i rmp-i-plus',
      null,
      null
    );
    this.#rmp.dom.controlBar.appendChild(plus);
    this.#rmp.rmpAccessible.button(plus, this.#rmp.labels.hint.plus, true);
    this.#audioOnlyPlusFn = this.#audioOnlyPlus.bind(this);
    FW.addEvents(['touchend', 'click'], plus, this.#audioOnlyPlusFn);

    /* audio only spinner */
    const audioOnlySpinner = FW.createElement(
      'span',
      'rmp-audio-only-loading-spin',
      null,
      null
    );
    this.#rmp.dom.container.appendChild(audioOnlySpinner);

    this.#audioOnlyOnVolumeChangeFn = this.#audioOnlyOnVolumeChange.bind(this);
    this.#rmp.dom.video.addEventListener('volumechange', this.#audioOnlyOnVolumeChangeFn);
  }

}
